import keyMirror from 'react-utils/keyMirror';
export const AdminRecoveryEligibilityStatuses = keyMirror({
  UNATTEMPTED: null,
  REQUESTING: null,
  ELIGIBLE: null,
  FORCED_ELIGIBLE: null,
  INELIGIBLE: null
});